import * as React from "react";
import {Fragment} from "react";
import Frame from "./Frame";

class Top extends React.Component {

	constructor(props) {
		super(props);
	}

	// shouldComponentUpdate(nextProps, nextState, nextContext) {
	// 	return false;
	// }

	componentDidMount() {
		const {onClick} = this.props;
		document.addEventListener('keydown', function(event) {
			if (event.key === 'Escape' || event.keyCode === 27) {
				onClick();
			}
		});
	}

	render() {

		const {onClick, fullScreen, background, product, single} = this.props;

		return (
			<Fragment>
				<div className="row h-100 align-items-center">
					<div className="col">
						{/*<div className="iframe"></div>*/}
						<Frame shortcut={product.shortcut} single={single} />
						<span id="fullscreenInfo" className="d-block text-center mt-5 d-none">
							Zum Verlassen der Vollbildansicht drücken Sie ESC oder klicken Sie <button type="button" className="btn btn-link p-0 m-0" style={{verticalAlign: 'unset'}} onClick={() => onClick()}>hier</button>.
						</span>
					</div>
				</div>
			</Fragment>
		);
	}
}

export default Top;
